import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchCorpoActivityArgs,
  FetchCorpoStatsArgs,
} from '../api/types/corpoStats.types';

import { fetchCorpoActivity, fetchCorpoStats } from '../api/corpoStats.api';

export const corpoStatsQueryKeys = createQueryKeys('corpoStats', {
  fetchActivity: (args: FetchCorpoActivityArgs) => ({
    queryFn: () => fetchCorpoActivity(args),
    queryKey: [args],
  }),
  fetchStats: (args: FetchCorpoStatsArgs = {}) => ({
    queryFn: () => fetchCorpoStats(args),
    queryKey: [args],
  }),
});
